import moment from 'moment'

export const dropdownTopCountries = new Set(['GB', 'US'])
export const dropdownTopLangs = new Set(['en_GB', 'en_US'])

// from GET '/template/product'
export const excludeTemplateIds = [6252] // using 6763 instead

export const templateProductStatus = 5

export const allowedTemplateIndustries = ['EV', 'CE', 'VENU']

// used for Rapid and Template surveys
export const defaultProdDetails = {
    numVisitors: 250,
    numExhibitors: 5,
    venueId: 3236,
    template: {
        startDate: moment().startOf('year').format('YYYY-MM-DD'),
        closeDate: moment().endOf('year').format('YYYY-MM-DD'),
    },
}

export const surveyOptionEnum = {
    CLIENT_TEMPLATE: 0,
    EXPLORI_TEMPLATE: 1,
    CLIENT_SURVEYS: 2,
    MAXBI_COMPLETE: 3,
    MAXBI_COPY: 4,
    BLANK_SURVEY: 5,
}

export const exploriTemplateAccess = [{ oid: 3, rid: 1 }]
